import React from "react";

const RentalCircleIcon = ({
  size = 12,
  fillBg = "#FAD152",
  strokeIcon = "#085054",
}) => {
  return (
    <span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 12 12"
      >
        <path
          fill={fillBg}
          stroke={fillBg}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M6 11A5 5 0 1 0 6 1a5 5 0 0 0 0 10"
        />
        <path
          stroke={strokeIcon}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d="m8.577 6.91-1.52 1.52M3.426 6.91h5.15M3.426 5.09l1.52-1.52M8.576 5.09h-5.15"
        />
      </svg>
    </span>
  );
};

export default RentalCircleIcon;
